// extracted by mini-css-extract-plugin
export default {"formContainer":"SetUpPassword_formContainer__zuOMz","passwordInputContainer":"SetUpPassword_passwordInputContainer__i9s-B","confirmButton":"SetUpPassword_confirmButton__9oVFX"};